/**
 * Riverside Team ops panel — UI gate only.
 *
 * Deliberately different from `src/utils/admin.js`: that module falls back to a
 * hardcoded default when the env var is blank, so a misconfigured deploy still
 * has a working admin. The team gate FAILS CLOSED instead — an unset
 * REACT_APP_TEAM_LOGIN_EMAIL grants the team panel to nobody. There is no
 * bootstrap problem to solve here (an admin provisions the account), so the
 * safer default wins.
 *
 * This is UX only. The real boundary is TEAM_LOGIN_EMAIL on the `ops-console`
 * edge function, which runs with the service role. Anything this file allows is
 * still rejected server-side if the JWT's email doesn't match.
 */

/** Single address, not a list — a comma means misconfiguration, so fail closed. */
function parseTeamLoginEmail(raw) {
  const source = raw?.trim();
  if (!source) return null;
  if (source.includes(',')) return null;
  return source.toLowerCase();
}

export function getTeamLoginEmail() {
  return parseTeamLoginEmail(process.env.REACT_APP_TEAM_LOGIN_EMAIL);
}

export function isTeamEmail(email) {
  if (!email) return false;
  const teamEmail = getTeamLoginEmail();
  if (!teamEmail) return false;
  return email.toLowerCase() === teamEmail;
}
